class LaunchFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('change', (e) => {
      const input = e.target;
      if (input && input.matches('input[type="radio"][name="filter"]')) {
        const allLink = facetForm.querySelector('[data-all-pill]');
        if (allLink) {
          allLink.removeAttribute('aria-current');
        }
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : LaunchFiltersForm.searchParamsInitial;
      if (searchParams === LaunchFiltersForm.searchParamsPrev) return;
      LaunchFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    LaunchFiltersForm.searchParamsPrev = searchParams;
    const sections = LaunchFiltersForm.getSections();

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      LaunchFiltersForm.filterData.some(filterDataUrl)
        ? LaunchFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : LaunchFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) LaunchFiltersForm.updateURLHash(searchParams);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll('#LaunchFiltersForm .js-filter');
    const facetDetailsElementsFromDom = document.querySelectorAll('#LaunchFiltersForm .js-filter');

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    facetDetailsElementsFromFetch.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        LaunchFiltersForm.filterData = [...LaunchFiltersForm.filterData, { html, url }];
        LaunchFiltersForm.renderFilters(html, event);
        LaunchFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

        if (typeof injectInfusionTemplates === 'function') {
          injectInfusionTemplates();
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = LaunchFiltersForm.filterData.find(filterDataUrl).html;
    LaunchFiltersForm.renderFilters(html, event);
    LaunchFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

    if (typeof injectInfusionTemplates === 'function') {
      injectInfusionTemplates();
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form, multiFilter) {
    const formData = new FormData(form);
    const searchParams = new URL(window.location.href).searchParams;
    const formParams = new URLSearchParams(formData).toString().replace(/=on/g, "");

    for (const key of Array.from(searchParams.keys())) {
      if (key === 'page' || key.startsWith('page_')) {
        searchParams.delete(key);
      }
    };
    searchParams.delete('filter');

    if (formParams !== '') {
      if(multiFilter){
        searchParams.append('filter', formParams);
      } else {
        const firstParam = formParams.split("&")[0];
        if(firstParam){
          searchParams.append('filter', firstParam.split("=")[1]);
        }
      }
    }

    return searchParams;
  }

  onSubmitForm(searchParams, event) {
    LaunchFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('launch-filters-form form');

    const forms = [];

    sortFilterForms.forEach((form) => {
      const multiFilter = form.dataset.multiFilter === 'true' ? true : false;
      forms.push(this.createSearchParams(form, multiFilter));
    });

    this.onSubmitForm(forms.join(','), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    LaunchFiltersForm.renderPage(url);
  }
}

LaunchFiltersForm.filterData = [];
LaunchFiltersForm.searchParamsInitial = window.location.search.slice(1);
LaunchFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('launch-filters-form', LaunchFiltersForm);
LaunchFiltersForm.setListeners();

class LaunchFacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('launch-filters-form') || document.querySelector('launch-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('launch-facet-remove', LaunchFacetRemove);
